
import { Reducer } from "redux";
import { RoutingState, PushRouterAction } from "./types";
import { PUSH_NEW_ROUTE } from "./constants";
import { Routes } from "../../constants/routes";


export const initialState: RoutingState = {
    currentRoute: Routes.root
};

const reducer: Reducer<RoutingState> = (state: RoutingState = initialState, action: PushRouterAction) => {
    if (action.type === PUSH_NEW_ROUTE) {
        return Object.assign({}, { currentRoute: action.payload.route });
    }
    return state;
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/Routing/reducer.ts